import React from 'react';

interface AddButtonProps {
  label: string;
  onClick: () => void;
}

const AddButton: React.FC<AddButtonProps> = ({ label, onClick }) => {
  return (
    <button
      className="bg-primary/300 text-white h-10 px-6 rounded-md"
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default AddButton;
